
/* eslint-disable */
import * as conditioner from 'conditioner-core/conditioner-core.min';
//import Lenis from "./modules/lenis"
import Placeholder from './modules/placeholder';

const placeholder = new Placeholder();

// lenis smooth scroll
/**/
/*const lenis = new Lenis({
    autoRaf: true
})*/



// paramsdatas
const appjs = document.getElementById('appjs');
const ParamsData = {};
if (appjs) {
    for (let key in appjs.dataset) {
        ParamsData[key] = appjs.dataset[key];
    }
}
//export { ParamsData, lenis };
export { ParamsData };

// print css
if (appjs) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.media = 'print';
    link.href = `${ParamsData.wp_theme_url}/assets/print.css`;
    document.head.appendChild(link);
}
// OneTrust Cookies Consent
// ParamsData.onetrust_id && import('./modules/onetrust').then(module => module.Onetrust());

// MarkerIo bugReports
ParamsData.bug_report_id && import('./modules/markerIo').then(module => module.bugReport());



// Conditioner
conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
        // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);



const hero_homepage = document.querySelector(".hero-homepage");
if (hero_homepage) {
    const cards = hero_homepage.querySelectorAll(".card-flex");
    
    const onresize = () => {
        for (let card of cards) {
            card.classList.remove("hide") ;
            if (card.offsetTop + card.offsetHeight > window.innerHeight) {
                card.classList.add("hide") ;
            }
        }
    }

    window.addEventListener("resize", onresize, { passive: true });
    
    onresize();
}